import { render, staticRenderFns } from "./DashboardPanel.vue?vue&type=template&id=425b05bb&scoped=true"
import script from "./DashboardPanel.vue?vue&type=script&lang=js"
export * from "./DashboardPanel.vue?vue&type=script&lang=js"
import style0 from "./DashboardPanel.vue?vue&type=style&index=0&id=425b05bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425b05bb",
  null
  
)

export default component.exports